export const nodeVertexShader = `
  attribute vec2 a_position;
  attribute float a_size;
  attribute float a_opacity;
  attribute float a_type;

  uniform float u_time;
  uniform vec2 u_resolution;
  uniform float u_aspect;

  varying float v_opacity;
  varying float v_type;

  void main() {
    vec2 pos = vec2(a_position.x / u_aspect, a_position.y);
    gl_Position = vec4(pos, 0.0, 1.0);
    float minDim = min(u_resolution.x, u_resolution.y);
    gl_PointSize = a_size * (minDim / 400.0);
    float pulse = 0.85 + 0.15 * sin(u_time * 0.003 + a_position.x * 8.0 + a_position.y * 6.0);
    v_opacity = a_opacity * pulse;
    v_type = a_type;
  }
`;

export const nodeFragmentShader = `
  precision mediump float;

  varying float v_opacity;
  varying float v_type;
  uniform vec3 u_color;
  uniform vec3 u_color2;

  void main() {
    vec2 center = gl_PointCoord - vec2(0.5);
    float dist = length(center);
    if (dist > 0.5) discard;

    vec3 col = mix(u_color, u_color2, v_type);

    if (v_type > 0.5) {
      float ring = smoothstep(0.35, 0.38, dist) * smoothstep(0.48, 0.42, dist);
      float core = smoothstep(0.2, 0.0, dist);
      float alpha = (ring * 0.8 + core) * v_opacity;
      gl_FragColor = vec4(col, alpha);
    } else {
      float glow = smoothstep(0.5, 0.0, dist);
      float core = smoothstep(0.18, 0.0, dist);
      float alpha = (glow * 0.5 + core * 0.8) * v_opacity;
      gl_FragColor = vec4(col, alpha);
    }
  }
`;

export const lineVertexShader = `
  attribute vec2 a_position;
  attribute float a_alpha;

  uniform float u_aspect;

  varying float v_alpha;

  void main() {
    vec2 pos = vec2(a_position.x / u_aspect, a_position.y);
    gl_Position = vec4(pos, 0.0, 1.0);
    v_alpha = a_alpha;
  }
`;

export const lineFragmentShader = `
  precision mediump float;

  varying float v_alpha;
  uniform vec3 u_color;

  void main() {
    gl_FragColor = vec4(u_color, v_alpha * 0.35);
  }
`;

export const packetVertexShader = `
  attribute vec2 a_position;
  attribute float a_size;
  attribute float a_opacity;

  uniform vec2 u_resolution;
  uniform float u_aspect;

  varying float v_opacity;

  void main() {
    vec2 pos = vec2(a_position.x / u_aspect, a_position.y);
    gl_Position = vec4(pos, 0.0, 1.0);
    float minDim = min(u_resolution.x, u_resolution.y);
    gl_PointSize = a_size * (minDim / 350.0);
    v_opacity = a_opacity;
  }
`;

export const packetFragmentShader = `
  precision mediump float;

  varying float v_opacity;
  uniform vec3 u_color;

  void main() {
    float dist = length(gl_PointCoord - vec2(0.5));
    if (dist > 0.5) discard;
    float glow = exp(-dist * 6.0);
    gl_FragColor = vec4(u_color, glow * v_opacity);
  }
`;

export const bgVertexShader = `
  attribute vec2 a_position;

  void main() {
    gl_Position = vec4(a_position, 0.0, 1.0);
  }
`;

export const bgFragmentShader = `
  precision mediump float;

  uniform vec2 u_resolution;
  uniform float u_time;

  void main() {
    vec2 uv = gl_FragCoord.xy / u_resolution;
    vec2 p = uv * 2.0 - 1.0;
    p.x *= u_resolution.x / u_resolution.y;

    float hex_size = 0.08;
    vec2 h = vec2(hex_size * 1.732, hex_size * 2.0);
    vec2 a = mod(p, h) - h * 0.5;
    vec2 b = mod(p - h * 0.5, h) - h * 0.5;
    float da = length(a);
    float db = length(b);
    float d = min(da, db);

    float hexEdge = smoothstep(hex_size * 0.85, hex_size * 0.88, d)
                  * smoothstep(hex_size * 0.95, hex_size * 0.9, d);

    float wave = 0.5 + 0.5 * sin(u_time * 0.0004 + uv.x * 4.0 + uv.y * 3.0);
    float alpha = hexEdge * 0.08 * wave;

    float scanline = smoothstep(0.002, 0.0, abs(fract(uv.y * 80.0 + u_time * 0.0002) - 0.5) - 0.48);
    alpha += scanline * 0.015;

    float vignette = 1.0 - smoothstep(0.5, 1.8, length(p));
    alpha *= (0.5 + vignette * 0.5);

    gl_FragColor = vec4(0.1, 0.45, 1.0, alpha);
  }
`;



